import { render, staticRenderFns } from "./PdpTabs.vue?vue&type=template&id=1ba76220"
import script from "./PdpTabs.vue?vue&type=script&lang=js"
export * from "./PdpTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports